window.addEventListener('resize', initPageTiles);

export function initPageTiles() {
  const pageTiles = document.querySelectorAll(
    '.tile-description-link .c-label, .tile-link .has-description'
  );
  if (pageTiles.length === 0) return;

  pageTiles.forEach((label) => {
    const height = label.querySelector('.c-description')?.offsetHeight;
    if (!height) return;
    label.style.setProperty('--description-height', `${height}px`);
  });
}
